"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initInbox = initInbox;
exports.INBOX_INIT = void 0;
var INBOX_INIT = "inbox/INIT";
exports.INBOX_INIT = INBOX_INIT;

function initInbox(payload) {
  return {
    type: INBOX_INIT,
    payload: payload
  };
}